import store from "@src/reducers/store";
import { formatChartXAxisDate } from "@src/cloud-connect/utils/timezone-display-utils";

export const formatDateTimeForGraphLabel = (value: string | number | Date) => {
  const timezone = store.getState().yourSlice.timezone;
  return formatChartXAxisDate(value, timezone);
};
